import ambientMusicUrl from '../../../assets/music/Musica_ÑacaÑaca.mp3';

// Volumen moderado para no tapar efectos ni voces del mapa.
// 0 = silencio, 1 = máximo. 0.4 queda de fondo sin molestar.
export const MAP_AMBIENT_VOLUME = 0.4;

let sharedAudio = null;

// Un solo reproductor para toda la app. Crearlo (y pedir el archivo)
// desde el arranque permite que el mp3 se descargue mientras el jugador
// está en el login, así al llegar al mapa ya está en caché y suena al instante.
export function getMapAmbientAudio() {
  if (!sharedAudio) {
    sharedAudio = new Audio();
    sharedAudio.src = ambientMusicUrl;
    sharedAudio.loop = true;
    sharedAudio.volume = MAP_AMBIENT_VOLUME;
    sharedAudio.preload = 'auto';
  }
  return sharedAudio;
}

const MUTED_STORAGE_KEY = 'nacanaca-map-music-muted';

const isMapMusicMuted = () => {
  try {
    return localStorage.getItem(MUTED_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export function preloadMapAmbientMusic() {
  try {
    // load() inicia la descarga sin reproducir.
    getMapAmbientAudio().load();
  } catch {
    // Si falla, el mapa lo intentará de nuevo al montarse.
  }
}

// Arranque instantáneo al iniciar sesión: se llama en el mismo gesto/flujo
// del login (saveUser, enlace mágico, sesión recordada) para que el mp3 —
// que ya se precargó desde el arranque — empiece a sonar sin esperar al
// montaje del mapa ni al iframe. Si el navegador bloquea el autoplay,
// resuelve false y MapAmbientAudio lo reintentará con el siguiente gesto.
export function startMapAmbientMusic() {
  try {
    if (isMapMusicMuted()) return Promise.resolve(false);
    const audio = getMapAmbientAudio();
    audio.loop = true;
    audio.volume = MAP_AMBIENT_VOLUME;
    audio.muted = false;
    if (!audio.paused) return Promise.resolve(true);
    const attempt = audio.play();
    if (attempt && typeof attempt.then === 'function') {
      return attempt.then(() => true).catch(() => false);
    }
    return Promise.resolve(true);
  } catch {
    return Promise.resolve(false);
  }
}
